import { FC } from 'react';
import cn from 'classnames';

import type { UploadTranslations } from '../types';
import styles from '../FileUploader.module.scss';

interface UploadedFilesListProps {
    files: string[];
    existingFiles?: string[];
    allowRemove?: boolean;
    showEmptyState?: boolean;
    onRemove?: (name: string) => void;
    translations: UploadTranslations;
}

export const UploadedFilesList: FC<UploadedFilesListProps> = ({
    files,
    existingFiles = [],
    allowRemove = false,
    showEmptyState = true,
    onRemove,
    translations,
}) => {
    const hasFiles = files.length > 0;

    const listClassName = cn(
        styles.filesList,
        !allowRemove && (hasFiles ? styles.filesListInline : styles.filesListInlineHidden)
    );

    if (!hasFiles && !showEmptyState) {
        return null;
    }

    return (
        <ul className={listClassName}>
            {hasFiles ? (
                files.map((name) => {
                    const isExisting = existingFiles.includes(name);
                    const canRemove = allowRemove && !isExisting;

                    return (
                        <li key={name} className={styles.fileItem}>
                            {allowRemove && (
                                <span className={styles.fileItemIcon} aria-hidden />
                            )}
                            <span className={styles.fileName}>{name}</span>
                            {canRemove && (
                                <button
                                    type="button"
                                    className={styles.fileRemove}
                                    onClick={() => onRemove?.(name)}
                                    aria-label={translations.removeFile}
                                >
                                    ×
                                </button>
                            )}
                        </li>
                    );
                })
            ) : (
                <li className={styles.filesListPlaceholder}>
                    {translations.noFiles}
                </li>
            )}
        </ul>
    );
};
